/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Participatedulheftcampuskurve5Inputs */

const de__field_participatedulheftcampuskurve5 = /** @type {(inputs: _Field_Participatedulheftcampuskurve5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilgenommen an ÜL-Heft Campuskurve`)
};

/**

* @param {_Field_Participatedulheftcampuskurve5Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_participatedulheftcampuskurve5 = /** @type {((inputs?: _Field_Participatedulheftcampuskurve5Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Participatedulheftcampuskurve5Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_participatedulheftcampuskurve5(inputs)
});
export { _field_participatedulheftcampuskurve5 as "_field_participatedULHeftCampusKurve" }